<app-content-container [isLoading]="isProductsStepLoading$ | async" [error]="productsStepError$ | async">
  <app-product-items></app-product-items>
  <div *ngIf="(hasInsuranceRequirements$ | async) === true" class="mt-5">
    <app-insurance-requirements></app-insurance-requirements>
  </div>

  <app-wizard-footer [submitForm]="onSubmit.bind(this)"></app-wizard-footer>
</app-content-container>
